import { useAdFleetMapVehicles } from '@backoffice-frontend/ad-fleet-map'
import { useAdVehicleStream } from '@backoffice-frontend/ad-vehicle-stream'
import { Button, LoadingIndicator } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import { useTakeOverButtonStartHandlingVehicleMutation } from './TakeOverButton.hook'

type TakeOverButtonProps = {
  vehicleId: string
  size?: 'compact' | 'default'
}

export const TakeOverButton = ({
  vehicleId,
  size = 'default',
}: TakeOverButtonProps) => {
  const { t } = useTranslation()
  const { selectVehicle } = useAdFleetMapVehicles()
  const { pendingUpdate, setPendingUpdate } = useAdVehicleStream()

  const [startHandlingVehicle, { loading }] =
    useTakeOverButtonStartHandlingVehicleMutation()

  const isLoading = loading || pendingUpdate

  const handleTakeOver = async () => {
    setPendingUpdate(true)
    await startHandlingVehicle({
      variables: { vehicleId },
      onError: () => {
        setPendingUpdate(false)
      },
    })
    selectVehicle(vehicleId)
  }

  return (
    <Button
      label={t('common_takeOver_button')}
      size={size}
      onClick={handleTakeOver}
      disabled={isLoading}
      icon={isLoading ? <LoadingIndicator /> : undefined}
    />
  )
}
